import { useState } from "react";
import { Select, MultiSelect, Button, Group, Flex } from "@mantine/core";
import { useExportRegistrations } from "../../api/registrations";
import { modals } from "@mantine/modals";

function ExportRegistrations({ eventId }) {
  const [timeFrame, setTimeFrame] = useState("all");
  const [statuses, setStatuses] = useState([]);
  const [format, setFormat] = useState("csv");
  const [groupBy, setGroupBy] = useState("registrations");

  const { mutate, isPending } = useExportRegistrations();

  const handleExport = async () => {
    mutate({
      eventId,
      timeFrame,
      statuses,
      format,
      groupBy,
    });
  };

  return (
    <Flex direction="column" gap="md">
      <Group justify="space-between">
        <Select
          label="Time Frame"
          value={timeFrame}
          onChange={setTimeFrame}
          data={[
            { value: "24h", label: "Last 24 Hours" },
            { value: "7d", label: "Last 7 Days" },
            { value: "30d", label: "Last 30 Days" },
            { value: "all", label: "All Time" },
          ]}
        />
        <MultiSelect
          label="Statuses"
          value={statuses}
          onChange={setStatuses}
          data={[
            { value: "pending", label: "Pending" },
            { value: "approved", label: "Approved" },
            { value: "rejected", label: "Rejected" },
            { value: "invoiced", label: "Invoiced" },
          ]}
          placeholder="Select statuses"
          clearable
        />
        <Select
          label="Format"
          value={format}
          onChange={setFormat}
          data={[
            { value: "csv", label: "CSV" },
            { value: "xlsx", label: "Excel (XLSX)" },
          ]}
        />
        <Select
          label="Group By"
          value={groupBy}
          onChange={setGroupBy}
          data={[
            { value: "registrations", label: "Registrations" },
            { value: "tickets", label: "Tickets" },
          ]}
        />
      </Group>
      <Button onClick={handleExport} loading={isPending}>
        Export Registrations
      </Button>
    </Flex>
  );
}

export function openExportModal(eventId) {
  return modals.open({
    title: "Export Registrations",
    children: <ExportRegistrations eventId={eventId} />,
    size: "lg",
    transitionProps: { transition: "fade", duration: 300 },
  });
}

export default ExportRegistrations;
